import { Button } from '@fluentui/react-components'
import React, { useContext } from 'react'
import { ModalActions } from '../common/modal/Modal'
import { Text } from '../common/text/Text'
import { DataContext } from '../../context/DataContext'
import { DemandAnalysis, DemandAnalysisStatus } from '../../api/schemas/schema'
import { handleMessage } from '../../helpers/stateHelper'
import { useNavigate } from 'react-router-dom'
import { t } from '../../i18n/i18n'
import { IItemState } from '../../interfaces/IItemState'
import { NavigationLink } from '../../interfaces/INavigationLink'
import { api } from '../../helpers/apiHelper'
import { DraggableModal } from '../common/modal/DraggableModal'

type ModalCompleteDemandAssessmentProps = {
   setAnalysisState: React.Dispatch<React.SetStateAction<IItemState<DemandAnalysis>>>
   analysisState: IItemState<DemandAnalysis>
   close: () => void
   open: boolean
}
export const ModalCompleteDemandAssessment = ({ setAnalysisState, analysisState, close, open }: ModalCompleteDemandAssessmentProps) => {
   const dataContext = useContext(DataContext)
   const { userAccount } = dataContext.state
   const navigate = useNavigate()
   const onComplete = async () => {
      try {
         setAnalysisState((prev) => ({ ...prev, loading: true }))
         const analysis = analysisState.item
         analysis.status = DemandAnalysisStatus.Completed
         analysis.modifiedBy = userAccount
         analysis.modifiedById = userAccount.id
         const updatedAnalysis = (await api().updateDemandAnalysis(analysis)).data
         setAnalysisState((prev) => ({ ...prev, loading: false, item: updatedAnalysis }))
         handleMessage(dataContext.setRootState, 'success', t('DemandAssessmentCompleted'))
         close()
         navigate(NavigationLink.ComplianceOfDemands + '?tab=concluded')
      } catch (error: any) {
         setAnalysisState((prev) => ({ ...prev, loading: false, error: error.error }))
         handleMessage(dataContext.setRootState, 'error', t('CouldNotCompleteDemandAssessment'), error.error.message)
         close()
      }
   }
   return (
      <DraggableModal title={t('CompleteDemandAssessment')} open={open} onClose={close} noDivider>
         <Text>{t('CompleteDemandAssessmentConfirmationMessage')}</Text>
         <ModalActions>
            <Button onClick={close}>{t('Cancel')}</Button>
            <Button appearance="primary" onClick={onComplete}>
               {t('CompleteDemandAssessment')}
            </Button>
         </ModalActions>
      </DraggableModal>
   )
}
